import React, { useState } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { BackButton, Button, Title } from '../../../components/UI/ComponentsUI';
import InputUI from '../../../components/UI/InputUI';
import PhysicalConfirmationService from '../../../services/PhysicalConfirmationService';
import { getVision } from '../../../services/auth';
import { ENUMS, VISIONS } from '../../../utils/constants';
import { validateInputsRequired } from '../../../utils/handleChangeHooks';
import { configs, isNullOrEmpty, showMessageToastCustom, translate } from '../../../utils/util';

const UpdateMvm = (props) => {
    const [mvmNumber, setMvm] = useState(undefined);
    const [journey, setJourney] = useState(undefined);
    const [supplier, setSupplier] = useState(undefined);
    const [invoice, setInvoice] = useState(undefined);

    const loadShedRequired = () => {
        const configItem = configs(ENUMS.eModules.PhysicalConfirmation.value, props.config?.items);
        return Boolean(configItem?.shedRequiredPhysicalConfirmation)
    }


    const onSubmit = () => {
        var shedRequired = loadShedRequired();
        if (isNullOrEmpty(journey) && isNullOrEmpty(mvmNumber)) {
            return showMessageToastCustom(translate('warning', 'general'), translate('required-fields', 'physical-confirmation'), 5000, 'mdi mdi-checkbox-marked-circle-outline red-text');
        }
        if (validateInputsRequired("formInput")) {
            props.updateMvm({
                mvmNumber,
                journey,
                supplier,
                invoice,
                shed: !shedRequired ? "" : props.sheds.find((i) => i.id === props.user.shed).code
            }, () => showMessageToastCustom(translate('confirmed', 'general'), translate('physical-confirmation:mvmupdated'), 8000, 'mdi mdi-checkbox-marked-circle-outline green-text'))
        }
    }

    return (
        <div>
            <BackButton {...props} />
            <div>
                <div className="container-fluid h-65" />
                <Title label={translate('physical-confirmation:mvm-update')} />
                <div className="container s12">
                    <div className="card">
                        <div className="card-content" style={{ padding: '10px' }}>
                            <div id="formInput" className="form-group">
                                <div className="row">
                                    {getVision() === VISIONS.Faasa || getVision() === VISIONS.FaasaCKD ?
                                        <>
                                            <div className="col s6 no-padding">
                                                <div className="input-field">
                                                    <InputUI
                                                        id="journey"
                                                        name="journey"
                                                        label={translate('physical-confirmation:journey')}
                                                        type="text"
                                                        defaultValue={journey || ''}
                                                        onChange={(evt) => setJourney(evt.target.value)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col s6 no-padding">
                                                <div className="input-field">
                                                    <InputUI
                                                        id="supplier"
                                                        name="supplier"
                                                        required
                                                        label={translate('supplier', 'physical-confirmation')}
                                                        type="text"
                                                        defaultValue={supplier || ''}
                                                        onChange={(evt) => setSupplier(evt.target.value)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col s6 no-padding">
                                                <div className="input-field">
                                                    <InputUI
                                                        id="invoice"
                                                        name="invoice"
                                                        required
                                                        label={translate('invoice', 'physical-confirmation')}
                                                        type="text"
                                                        defaultValue={invoice || ''}
                                                        onChange={(evt) => setInvoice(evt.target.value)}
                                                    />
                                                </div>
                                            </div>
                                        </>
                                        :
                                        <>
                                            <div className="col s6 no-padding">
                                                <div className="input-field">
                                                    <InputUI
                                                        id="mvmNumber"
                                                        name="mvmNumber"
                                                        label={translate('physical-confirmation:mvm')}
                                                        type="text"
                                                        defaultValue={mvmNumber || ''}
                                                        onChange={(evt) => setMvm(evt.target.value)}
                                                    />
                                                </div>
                                            </div>

                                            <div className="col s6 no-padding">
                                                <div className="input-field">
                                                    <InputUI
                                                        id="journey"
                                                        name="journey"
                                                        label={translate('physical-confirmation:journey')}
                                                        type="text"
                                                        defaultValue={journey || ''}
                                                        onChange={(evt) => setJourney(evt.target.value)}
                                                    />
                                                </div>
                                            </div>
                                        </>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col s12 lefth">
                            <Button
                                full="true"
                                className="col s6 btn-principal"
                                text={translate('physical-confirmation:mvm-update')}
                                onClick={onSubmit}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        sheds: state.configReducer.sheds,
        config: state.configReducer.config,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateMvm: (filter, callback) => {
            dispatch(PhysicalConfirmationService.updateMvm(filter, callback));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(UpdateMvm));